<template>
  <v-dialog v-model="showDialog" max-width="560" content-class="capture-image-dialog">
    <v-card>
      <v-card-title class="dialog-title">
        <!-- <v-btn v-if="item.status != 0" icon @click="$emit('imgStatusChange', imgIndex)" class="allow-btn" >
          <v-icon class="allow-icon" color="#10B981" size="18" align="center">check</v-icon>
        </v-btn> -->
        <v-btn v-if="statusIcon === 'check'" icon @click="$emit('imgStatusChange', imgIndex)" class="allow-btn" >
          <v-icon class="allow-icon" color="#10B981" size="18" align="center">{{statusIcon}}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-center pa-0" >
        <!-- <img
          v-if="item.data != null"
          :src="item.data"
          class="filter-list-image-item__img"
        />
        <img
          v-else
          :src="prefixServerImgPath(`${item.examinationID}/${item.file}`)"
          class="filter-list-image-item__img"
        /> -->
        <v-img min-height="400" v-if="item.data != null" :src="item.data" contain></v-img>
        <v-img v-else min-height="400" :src="prefixServerImgPath(item)" contain></v-img>
      </v-card-text>
      <v-card-actions class="dialog-action">
        <div class="img-serial pa-0">P{{ allImages.length - imgIndex }} </div>
        <div class="finding-name pa-4">{{ findingName }}{{ findingName !='' && landmarkText !='' ?' , ':'' }}{{ landmarkText }}</div>    
        <!-- <select-icon
          :value="item.landmarkID"
          :items="landmarkSelectItems"
          @change="landmarkChange(item.id, $event)"
        >
          <template slot-scope="props">
            <v-btn icon flat small v-on="props.on">
              <v-icon>location_on</v-icon>
            </v-btn>
          </template>
        </select-icon>
        <select-icon
          :value="item.findingID"
          :items="findingSelectItems"
          @change="findingChange(item.id, $event)"
        >
          <template slot-scope="props">
            <v-btn
              icon
              flat
              small
              dark
              :outline="findingIndex !== 0"
              class="action-btn finding"
              v-on="props.on"
            >
              <v-icon v-if="findingIndex === 0">label</v-icon>
              <span v-else>{{ findingIndex }}</span>
            </v-btn>
          </template>
        </select-icon> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectIcon from '@/components/screenshots/SelectIcon'
import findingMixins from '@/mixins/findingMixins.js'
export default {
  components: {
    SelectIcon
  },
  mixins: [findingMixins],
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    getFindings: {
      type: Array,
      required: true
    },
    imgIndex: {
      type: Number,
      required: true
    },
    allImages: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('examinations', [
      'getLandmarkList',
      'getFindingNameMap',
      'getCurrentCaptureImage'
    ]),
    statusIcon() {
      return this.item?.status == 0 ? 'print' : 'check'
    },
    findingIndex() {
      if (this.item) {
        const findingID = Number.parseInt(this.item.findingID)
        const index = this.getFindings.findIndex(({ id }) => id === findingID)
        return index + 1
      }
      return 0
    },
    landmarkSelectItems() {
      let items = this.getLandmarkList.map(elm => {
        return {
          value: elm.id,
          text: elm.landmark
        }
      })

      items.unshift({
        value: 0,
        text: this.$t('common.choose')
      })

      return items
    },
    findingSelectItems() {
      console.log('findingSelectItems', this.getFindings)
      let items = this.getFindings.map((elm, index) => {
        return {
          value: elm.id,
          text: `Finding ${index + 1}`
        }
      })

      items.unshift({
        value: 0,
        text: this.$t('common.choose')
      })

      return items
    },
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$nextTick(() => {
          console.log('set showDialog', value)
          this.$emit('close', value);  
        })
      }
    },
    landmarkText() {
      if (this.item.landmarkID != 0 && this.landmarkSelectItems.length) {
        const landmark = this.landmarkSelectItems.find(e => e.value === this.item.landmarkID)
        if (landmark) {
          return landmark.text.replace(/(\Wof\Wcolon|\Wcolon)$/ig, '')
        }
      }
      return ''
    },
    findingName() {
      let _arr = {}
      const findingMap = this.getFindings.find(row => row.id === this.item.findingID)
      if (findingMap) {
        const findingMapId = findingMap.questions.finding.value
        return this.getFindingNameMap[findingMapId]
      }
      
      
      return ''
      // return _arr[this.getFindings.find(row => row.id === this.item.examinationID).this.item.findingID]
    },
  },
  methods: {
    landmarkChange(id, v) {
      this.$emit('landmarkChange', {
        id,
        newValue: v
      })
    },
    findingChange(id, v) {
      console.log('findingChange', id, v)
      this.$emit('findingChange', {
          id,
          newValue: v
        })
    },
  },
  // watch: {
  //   show(value) {
  //     console.log('show', value)
  //     this.showDialog = value;
  //   }
  // }
};
</script>
<style>
.capture-image-dialog{
  border-radius: 10px;
}
</style>
<style scoped>

.dialog-title {
  position: absolute;
  right: 0px;
  z-index: 10;
}
/* .dialog-title:hover .allow-icon{
  display: block;
  
} */
.v-card-text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.allow-btn::before{
  background: transparent !important;
  display: none !important;
}
.allow-btn{
  background-color: rgba(222,222,222, 0.4) ; 
  border-radius: 50%;
  width: 44px;
  height: 44px;
}
.allow-icon{
  background-color: rgba(255,255,255, 1); 
  border-radius: 50%;
  font-size: 24px;
  color: #10B981;
  /* display: none; */
  width: 28px;
  height: 28px;
  vertical-align: middle;
}
.dialog-action{
  background-color:#14B8A6;
  height:100px;
  grid-row: 155px 1fr;
  padding: 24px;
}
.img-serial{
  background-color:#ffffff;
  width:80px;
  height: 40px;
  font-size: 20px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
}
.finding-name{
  color: #ffffff; 
  font-size: 20px;
  align-items: center;
  display: flex;
}
</style>
